export default "__VITE_ASSET__58LYygvD__"